var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "strong" }, [
      _vm._v(_vm._s(_vm.widget.label || _vm.widget.id))
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "hover-shadow box-border-7",
        staticStyle: { padding: "5px", "margin-top": "5px" }
      },
      [
        !_vm.segments || _vm.segments.length < 1
          ? _c("div", { staticStyle: { color: "#EEE", "font-size": "20px" } }, [
              _vm._v("没有...")
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.segments, function(e) {
          return _c("span", { key: e, staticClass: "segment-span" }, [
            _vm._v(_vm._s(e))
          ])
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5f1f0f10", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f1f0f10","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticket/TicketWidgetSegment.vue
// module id = 830
// module chunks = 75